import { Component, ElementRef, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';
import { WorkflowStep } from '@app/models/workflow-step';
import { StepperService } from '@app/services/stepper.service';
import { StoreService } from '@app/services/store.service';
import { map, Observable } from 'rxjs';
import { ApplicationEnvironment } from 'src/environments/app-environment';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'mv-celebration',
	templateUrl: './celebration.component.html',
	styleUrls: ['./celebration.component.scss'],
})
export class CelebrationComponent implements OnInit {
	@HostBinding('class.emb-element') klassName = true;
	@Output() _emb_close: EventEmitter<boolean> = new EventEmitter<boolean>();
	public petName$: Observable<string> = this.storeService.appState$.pipe(map(s => s.petName ?? ''));
	public clinicName$: Observable<string> = this.storeService.formState$.pipe(map(s => s.vetClinic?.accountName ?? ''));
	public cannotFindVet$: Observable<boolean> = this.storeService.formState$.pipe(map(s => s.cannotFindVet));
	public newVetClinicName$: Observable<string> = this.storeService.formState$.pipe(map(s => s.newVetClinic.name ?? ''));
	private readonly workflowStep: number = 4;

	constructor(
		public readonly storeService: StoreService,
		public readonly stepperService: StepperService,
		public readonly el: ElementRef<HTMLElement>
	) {}

	public get partyHornSrc(): string {
		let env: string;
		switch (environment.appEnvironment) {
			case ApplicationEnvironment.DEV:
			case ApplicationEnvironment.LOCAL:
				env = '-dev';
				break;
			case ApplicationEnvironment.RC:
				env = '-rc';
				break;
			case ApplicationEnvironment.PROD:
			default:
				env = '';
				break;
		}

		return `https://epiassets.azureedge.net/assets${env}/elements/my-vets/assets/party-horn.png`;
	}

	ngOnInit(): void {
		this.stepperService.updateStep(this.workflowStep);
	}

	public addAdditionalVet(): void {
		this.storeService.updateWorkflowStep(WorkflowStep.VetClinic);
		this.storeService.cleanupFormState();

		const updateEvent: CustomEvent = new CustomEvent('emb_mv:global_update', { bubbles: true });
		this.el.nativeElement.dispatchEvent(updateEvent);
	}

	public close(): void {
		this._emb_close.emit(true);
		this.storeService.cleanupFormState();
	}
}
